/**
 * Builds a nested object structure from dot-notation field paths
 */
export function buildFieldTree(fields: Set<string> | string[]): any {
  const tree: any = {};

  fields.forEach((field) => {
    if (!field) return;
    const parts = field.split(".");
    let current = tree;

    parts.forEach((part, index) => {
      if (index === parts.length - 1) {
        if (!current.__fields) {
          current.__fields = [];
        }
        if (!current.__fields.includes(part)) {
          current.__fields.push(part);
        }
      } else {
        if (!current[part]) {
          current[part] = {};
        }
        current = current[part];
      }
    });
  });

  return tree;
}

/**
 * Converts field tree to GraphQL selection string
 */
export function treeToGraphQL(tree: any, indent = "      "): string {
  const lines: string[] = [];

  if (tree.__fields) {
    tree.__fields.forEach((field: string) => {
      lines.push(`${indent}${field}`);
    });
  }

  Object.keys(tree).forEach((key) => {
    if (key !== "__fields") {
      lines.push(`${indent}${key} {`);
      lines.push(treeToGraphQL(tree[key], indent + "  "));
      lines.push(`${indent}}`);
    }
  });

  return lines.join("\n");
}
